// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XqvTt","label":"styles_label__2xWk5"};